import { FileResponse, GetDebtorDto } from 'api/api';
import actionCreatorFactory from 'typescript-fsa';
import { constants } from './constants';

const actionCreator = actionCreatorFactory('debtors');

export const GetDebtorImageAction = actionCreator.async<number, FileResponse | null>(constants.GET_DEBTOR_IMAGE);
export const GetDebtorAction = actionCreator.async<number, GetDebtorDto | null>(constants.GET_DEBTOR);
